import React, { ReactNode } from "react";
import styled from "styled-components";
import WarningIcon from "@material-ui/icons/Warning";
import { ErrorMessage } from "@sonder/ui/source/styled/fragments/Error";

export enum BatchJobType {
  Create = "Create",
  Update = "Update",
}
interface ToastMessageProps {
  total: number;
  remaining: number;
  errors?: any[];
  children: ReactNode;
  jobType: BatchJobType;
}

export const StyledToastMessage = styled.div`
  margin: 0 1rem;
  max-width: 20rem;
  max-height: 8.5rem;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 1rem;
`;

export const ToastTitle = styled.h4`
  margin: 0;
`;

export const ToastMessage = ({
  total,
  remaining,
  errors = [],
  children,
  jobType,
}: ToastMessageProps) => {
  const hasErrors = errors.length > 0;

  const pastTenseMessage =
    (jobType === BatchJobType.Create && "Creation Complete!") ||
    (jobType === BatchJobType.Update && "Update Complete!");

  const presentTenseAction =
    (jobType === BatchJobType.Create && "Creating") ||
    (jobType === BatchJobType.Update && "Updating");

  const subtitleMessage =
    (jobType === BatchJobType.Create &&
      `${total} ${total > 0 ? "tasks" : "task was"} created.`) ||
    (jobType === BatchJobType.Update &&
      `${total} ${total > 0 ? "updates" : "update"} applied.`);

  const errorCopy =
    (jobType === BatchJobType.Create &&
      `${errors.length} ${
        errors.length > 0 ? "tasks were" : "task was"
      } not created.`) ||
    (jobType === BatchJobType.Update &&
      `${errors.length} ${
        errors.length > 0 ? "updates were" : "update was"
      } unsuccessful.`);

  const message =
    remaining === 0
      ? pastTenseMessage
      : `${presentTenseAction} Tasks... (${total - remaining}/${total}).`;
  const subtitle = !hasErrors && remaining === 0 ? subtitleMessage : null;
  const errorMessage = hasErrors ? (
    <ErrorMessage>
      <WarningIcon />
      {` ${errorCopy}`}
    </ErrorMessage>
  ) : null;

  return (
    <StyledToastMessage>
      <ToastTitle>{message}</ToastTitle>
      {subtitle && <div>{subtitle}</div>}
      {errorMessage && <div>{errorMessage}</div>}
      {hasErrors && (
        <div>
          <hr />
          {children}
        </div>
      )}
    </StyledToastMessage>
  );
};
